import React, { Component } from 'react'
import styles from './index.module.less'
import appInstall from '@/utils/appUtils/appInstall'
import { LangEum, EditConfigType } from '@/typings/types'

interface IProps<T = any> {
  propsConfig: T
  editConfig: EditConfigType
  isShow: boolean
  callback: () => void
}

class Index extends Component<IProps, any> {
  static config = {
    name: 'poizon-download-bar',
  }

  constructor(props) {
    super(props)
    this.state = {
      closeCover:
        'https://cdn.poizon.com/node-common/MDglMjAlRTUlOUIlQkUlRTYlQTAlODdfY2xvc2VAM3gxNTg3MDQyMDQ2MjU0.png',
      logo: 'https://cdn.poizon.com/node-common/cG9pem9uXzEwOF8xMDhAM3gxNTg3MDQyMDYwNDE4.png',
    }
  }
  componentDidMount() {}

  close() {
    if (window.editorFlag === 'edit') return
    this.props.callback()
  }

  getDownBtnText() {
    const lang = this.props.editConfig?.lang || 'en'
    const zhTW = '下載應用程式'
    const downBtnTextMap = {
      zh: '活动规则',
      [LangEum['zh-MO']]: zhTW,
      [LangEum['zh-TW2']]: zhTW,
      [LangEum['zh-TW']]: zhTW,
      [LangEum['zh-SG']]: '活动规则',
      [LangEum['zh-MY']]: '活动规则',
      zh: '下载app',
      en: 'DOWNLOAD',
      ja: 'ダウンロード',
      ko: 'APP 다운',
    }
    return downBtnTextMap[lang] || downBtnTextMap['zh-TW']
  }

  download() {
    if (window.editorFlag === 'edit') return
    console.log('hhhhhhh...........下载应用')
    appInstall()
  }

  render() {
    if (!this.props.isShow) return ''
    return (
      <div className={styles['download-bar']}>
        <img
          className={styles.close}
          onClick={() => {
            this.close()
          }}
          src={this.state.closeCover}
          alt="x"
        />
        <img className={styles.logo} src={this.state.logo} alt="poizon" />
        <div className={styles.cont}>
          <div className={styles.tit}>{this.props?.propsConfig?.title || 'POIZON'}</div>
          <div className={styles.desc}>
            {this.props?.propsConfig?.desc || 'Stay Real to Fashion'}
          </div>
        </div>
        <button className={styles.down} onClick={() => this.download()}>
          {this.getDownBtnText()}
        </button>
      </div>
    )
  }
}

export default Index
